import { Circle, Polygon } from 'react-leaflet';
import { GeofenceShapeModel } from '@casops/store/apis/geofencesApi';
import { ReactElement, useMemo } from 'react';
import { commonPathDisplay } from '../geofence-layer/GeofenceLayer';
import { GEOFENCE_EDITOR_LAYER_CLASS, SHAPE_EDITOR_PANE_NAME } from '../../mapConfig';

export const GeofenceActiveColor = '#8C00FF';

export const activePathOptions: L.PathOptions = {
  ...commonPathDisplay,
  color: GeofenceActiveColor,
  fillColor: GeofenceActiveColor,
  className: GEOFENCE_EDITOR_LAYER_CLASS,
};

const geofenceEditorLayerOptions: L.PathOptions = {
  ...activePathOptions,
  pane: SHAPE_EDITOR_PANE_NAME,
};

export interface GeofenceEditorProps {
  geofenceShape: GeofenceShapeModel;
}

export function GeofenceEditor({
  geofenceShape: { shape, points, radius },
}: GeofenceEditorProps): ReactElement | null {
  /**
   * The map needs the coordinates in a different format than the API response.
   * Convert points (number[][]) to LatLng expression ([number, number]) and flip index order.
   */
  const geofencePoints = useMemo<L.LatLngExpression[]>(() => {
    return points.map(element => [element[1], element[0]]);
  }, [points]);

  if (shape === 'Circle' && geofencePoints.length === 1 && radius) {
    return <Circle center={geofencePoints[0]} radius={radius} {...geofenceEditorLayerOptions} />;
  } else if (shape === 'Polygon' && geofencePoints.length > 1) {
    return <Polygon positions={geofencePoints} {...geofenceEditorLayerOptions} />;
  } else {
    return null;
  }
}

export default GeofenceEditor;
